module.exports = __webpack_public_path__ + "img/mag (3).35823c12.png";